import { Button } from "antd";
import { useState } from "react";
import { Space } from "antd";
import PropTypes from "prop-types";

import { useAxiosPrivate } from "../../../hooks/useAxiosPrivate";
import { useSessionStore } from "../../../store/session-store";
import { useAlertStore } from "../../../store/alert-store";
import { useExceptionHandler } from "../../../hooks/useExceptionHandler";
import { useCustomToolStore } from "../../../store/custom-tool-store";

function PromptShareLinkFooter({ setOpenShareModal, setOpenShareLink }) {
  const { shareId, updateCustomTool } = useCustomToolStore();
  const axiosPrivate = useAxiosPrivate();
  const { sessionDetails } = useSessionStore();
  const { setAlertDetails } = useAlertStore();
  const handleException = useExceptionHandler();
  const [isShareCopyLoading, setIsShareCopyLoading] = useState(false);
  const [isStopShareLoading, setIsStopShareLoading] = useState(false);

  const handleStopSharing = () => {
    setIsStopShareLoading(true);
    const requestOptions = {
      method: "DELETE",
      url: `/api/v1/unstract/${sessionDetails?.orgId}/share-manager/${shareId}`,
      headers: {
        "X-CSRFToken": sessionDetails?.csrfToken,
      },
    };

    axiosPrivate(requestOptions)
      .then(() => {
        const updatedCusTool = { shareId: null };
        updateCustomTool(updatedCusTool);
        setOpenShareLink(false);
        setOpenShareModal(false);
        setAlertDetails({
          type: "success",
          content:
            "Public sharing permissions revoked sucessfully for the project.",
        });
      })
      .catch((err) => {
        setAlertDetails(
          handleException(err, "Failed to revoke share permissions")
        );
      })
      .finally(() => {
        setIsStopShareLoading(false);
      });
  };
  const handlePublicLinkCopy = () => {
    setIsShareCopyLoading(true);
    navigator.clipboard.writeText(
      window.location.origin + "/promptStudio/share/" + shareId
    );
    setAlertDetails({
      type: "success",
      content: "Public Project link copied to clipboard.",
    });
    setIsShareCopyLoading(false);
  };
  return (
    <div>
      <Space>
        <Button onClick={handleStopSharing} loading={isStopShareLoading}>
          Stop sharing
        </Button>
        <Button
          type="primary"
          onClick={handlePublicLinkCopy}
          loading={isShareCopyLoading}
        >
          Copy public link
        </Button>
      </Space>
    </div>
  );
}

PromptShareLinkFooter.propTypes = {
  setOpenShareModal: PropTypes.func.isRequired,
  setOpenShareLink: PropTypes.func.isRequired,
};
export { PromptShareLinkFooter };
